import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingBag, Minus, Plus, Trash2 } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { formatPrice } from '../../utils/price';

export default function Cart() {
  const navigate = useNavigate();
  const { cart, updateCartQuantity, removeFromCart, clearCart, cartTotal, refreshCart } = useApp();
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    refreshCart().finally(() => setInitialLoading(false));
  }, []);

  const total = cartTotal;

  return (
    <div className="pb-4 animate-fade-in">
      <header className="sticky top-0 z-30 bg-cream/85 px-4 pb-3 pt-4 backdrop-blur-xl">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="grid h-9 w-9 place-items-center rounded-xl bg-terracotta text-white">
              <ShoppingBag className="h-5 w-5" />
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-widest text-green-muted">Ваша корзина</div>
              <div className="-mt-0.5 text-base font-bold text-green-dark">
                Корзина
                <span className="ml-2 text-sm font-normal text-green-muted">· {cart.length}</span>
              </div>
            </div>
          </div>
          {cart.length > 0 && (
            <button onClick={clearCart} className="text-sm text-green-muted hover:text-[#D64545]">Очистить</button>
          )}
        </div>
      </header>

      <div className="px-4">
        {cart.length > 0 ? (
          <div className="space-y-3 pb-32">

            {cart.map(item => (
              <div key={`${item.id}:${item.variant_id || ''}`} className="flex items-center gap-3 rounded-2xl bg-cream-card p-3 ring-1 ring-border-warm">
                <div className="h-16 w-16 flex-shrink-0 rounded-xl bg-cream flex items-center justify-center text-2xl">
                  {item.image_url ? (
                    <img src={item.image_url} alt={item.name} className="h-full w-full object-cover rounded-xl" />
                  ) : '🌱'}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-green-dark truncate">{item.name}</h3>
                  {item.variant_label && (
                    <p className="text-xs text-green-muted">{item.variant_label}</p>
                  )}
                  <p className="text-sm font-bold text-green-dark">{formatPrice(item.price)} ₽</p>
                </div>
                <div className="flex items-center gap-2">
                  <button onClick={() => updateCartQuantity(item.id, item.quantity - 1, item.variant_id || null)} className="grid h-8 w-8 place-items-center rounded-lg bg-cream text-green-dark active:scale-90">
                    <Minus className="h-4 w-4" />
                  </button>
                  <span className="w-6 text-center text-sm font-bold">{item.quantity}</span>
                  <button onClick={() => updateCartQuantity(item.id, item.quantity + 1, item.variant_id || null)} className="grid h-8 w-8 place-items-center rounded-lg bg-green-primary text-white active:scale-90">
                    <Plus className="h-4 w-4" />
                  </button>
                  <button onClick={() => removeFromCart(item.id, item.variant_id || null)} className="grid h-8 w-8 place-items-center rounded-lg text-green-muted hover:text-[#D64545] active:scale-90">
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : initialLoading ? (
          <div className="flex items-center justify-center py-16">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-green-primary"></div>
          </div>
        ) : (
          <div className="rounded-2xl bg-cream-card py-16 text-center text-sm text-green-muted">
            <ShoppingBag className="mx-auto mb-2 h-8 w-8" />
            <p>Корзина пуста</p>
            <p className="mt-1 text-xs">Добавьте товары из каталога</p>
          </div>
        )}
      </div>

      {/* Фиксированный нижний бар с итого */}
      {cart.length > 0 && (
        <div className="fixed bottom-16 left-0 right-0 z-30 bg-cream-card border-t border-border-warm px-4 py-3 shadow-lg">
          <div className="mx-auto max-w-md">
            <div className="flex items-center justify-between mb-3">
              <div>
                <span className="text-xs text-green-muted">Итого</span>
                <div className="text-xl font-bold text-green-dark">{formatPrice(total)} ₽</div>
              </div>
              <span className="text-xs text-green-muted">{cart.length} товар(ов)</span>
            </div>
            <button
              onClick={() => navigate('/checkout')}
              className="w-full rounded-xl bg-terracotta py-3.5 text-sm font-semibold text-white shadow-sm transition hover:bg-terracotta/90 active:scale-[0.98]"
            >
              Оформить самовывоз
            </button>
          </div>
        </div>
      )}

    </div>
  );
}
